import React from "react";

import Container from "@material-ui/core/Container";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
// import LogoTokoRame from "../../assets/icon/Logo";
import LogoRamadhan from "../../assets/icon/LogoRamadhan"
import useStyles from "./style";

function AppLoading() {
  const classes = useStyles();
  const [viewportHeight, setViewportHeight] = React.useState(window.innerHeight);

  React.useEffect(() => {
    const handleResize = () => setViewportHeight(window.innerHeight);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Container maxWidth="xs">
      <div className={classes.loadingBox} style={{height: viewportHeight}}>
        <Typography variant="h6" component="h2" className={classes.title}>
          <LogoRamadhan className={classes.logo} />
        </Typography>
        <LinearProgress />
      </div>
    </Container>
  );
}

export default AppLoading;
